export const USER_ROLES = {
  ADMIN: 'admin',
  AUDITOR: 'auditor',
};
